import { useEffect } from 'react';
import usePostMessage from 'hooks/utils/usePostMessage';
import { isHylyghtAppAgent } from 'utils/browser';
import { StoreContext } from 'index';
import { useContext } from 'react';

const MobileAuth = () => {
  const { sendMessage, addEventListener, removeEventListener } =
    usePostMessage();
  const { authStore } = useContext(StoreContext);

  useEffect(() => {
    if (isHylyghtAppAgent()) {
      if (localStorage.getItem('logout') === 'true') {
        if (!authStore.isLoggedIn) {
          const data = {
            subject: 'logoutComplete'
          };
          sendMessage({ message: data });
          localStorage.removeItem('logout');
        }
      } else {
        addEventListener();
        sendNotAuthorized();
        return () => {
          removeEventListener();
        };
      }
    }
  }, []);

  const sendNotAuthorized = () => {
    const data = {
      subject: 'unauthorized'
    };
    sendMessage({ message: data });
  };
};

export default MobileAuth;
